import React, {useEffect, useState} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import classNames from 'classnames';
import Form_1 from '../Form_1';
import Form_3 from '../Form_3';
import Form_4 from '../Form_4';
import Form_5 from '../Form_5';
import Form_6 from '../Form_6';
import Form_8 from '../Form_8';
import Form_9 from '../Form_9';
import Form_10 from '../Form_10';
import Form_11 from '../Form_11';
import Form_12 from '../Form_12';
import Form_13 from '../Form_13';
import Spinner from 'common/components/Spinner';
import FormContainer from '../FormContainer';
import StepNumber from '../StepNumber';
import Dash from 'common/components/Dash';
import PopupMessage from '../PopupMessage';
import {pathnames as P} from 'common/constants/pathnames';
import stepIcon1 from 'common/assets/step-1.svg';
import stepIcon3 from 'common/assets/step-3.svg';
import stepIcon4 from 'common/assets/step-4.svg';
import stepIcon5 from 'common/assets/step-5.svg';
import stepIcon6 from 'common/assets/step-6.svg';
import stepIcon8 from 'common/assets/step-8.svg';
import stepIcon9 from 'common/assets/step-9.svg';
import stepIcon10 from 'common/assets/step-10.svg';
import stepIcon11 from 'common/assets/step-11.svg';
import stepIcon13 from 'common/assets/step-13.svg';
import {shumaType} from '../../../../common/constants/shumaType';
import {getStep12Title} from '../../utils/getStep12Title';
import styles from './styles.module.scss';

const BankIcon = <i className={`la la-bank ${styles.icon}`}/>;

const steps = [
  {
    id: 13,
    stepIcon: stepIcon13,
    hoverTopic: 'מידע כללי',
    topic: 'מידע כללי',
    component: Form_13,
  },
  {
    id: 4,
    stepIcon: stepIcon4,
    hoverTopic: 'תיאור הסביבה',
    topic: 'תיאור הסביבה',
    component: Form_4,
  },
  {
    id: 3,
    stepIcon: stepIcon3,
    hoverTopic: 'ביקור בנכס',
    topic: 'ביקור בנכס',
    component: Form_3,
  },
  {
    id: 1,
    stepIcon: stepIcon1,
    hoverTopic: 'פרטי הנכס ומצב משפטי',
    topic: 'פרטי הנכס ומצב משפטי',
    component: Form_1,
  },
  {
    id: 6,
    stepIcon: stepIcon6,
    hoverTopic: 'המצב התכנוני',
    topic: 'המצב התכנוני',
    component: Form_6,
  },
  {
    id: 5,
    stepIcon: stepIcon5,
    hoverTopic: 'שטחי הנכס',
    topic: 'שטחי הנכס',
    component: Form_5,
  },
  {
    id: 9,
    stepIcon: stepIcon9,
    hoverTopic: 'נכסי השוואה',
    topic: 'נכסי השוואה',
    component: Form_9,
  },
  {
    id: 10,
    stepIcon: stepIcon10,
    hoverTopic: 'תחשיב',
    topic: 'תחשיב',
    component: Form_10,
  },
  {
    id: 12,
    stepIcon: BankIcon,
    hoverTopic: getStep12Title,
    topic: getStep12Title,
    component: Form_12,
    allowedShumaTypeIDs: [
      shumaType.BANK_CODE_19,
      shumaType.BANK_FULL,
      shumaType.BANK_SHORT,
    ],
  },
  {
    id: 8,
    stepIcon: stepIcon8,
    hoverTopic: 'עקרונות גורמים ושיקולים',
    topic: 'עקרונות גורמים ושיקולים',
    component: Form_8,
  },
  {
    id: 11,
    stepIcon: stepIcon11,
    hoverTopic: 'הפקת דוח ומסמכים',
    topic: 'הפקת דוח ומסמכים',
    component: Form_11,
  },
];

const SpinnerContainer = () => (
  <div className={styles.spinnerContainer}>
    <Spinner/>
  </div>
);

const InspectionFormPageView = ({
                                  stepStatus,
                                  shumaId,
                                  firmShumaID,
                                  shumaTypeID,
                                  stepDataLoading,
                                  isStepAllowed,
                                  formId
                                }) => {
  const [allowShowSpinner, setAllowShowSpinner] = useState(false);
  useEffect(() => {
    setAllowShowSpinner(true);
  }, [formId]);

  useEffect(() => {
    if (!stepDataLoading) {
      setAllowShowSpinner(false);
    }
  }, [stepDataLoading]);

  const renderFormRoute = (step, ind) => {
    const {id, component} = step;
    const path = P.GET_FORM_BY_ID_AND_STEP(shumaId, id);
    return <Route path={path} component={component} key={ind}/>;
  };

  const getTopic = (topic, shumaTypeID) => {
    switch (typeof topic) {
      case 'function':
        return topic(shumaTypeID);
      case 'string':
      default:
        return topic;
    }
  }

  const renderSteps = () => {
    return steps.map((step, ind) => {
      const {
        id,
        hoverTopic,
        topic,
        stepIcon,
      } = step;
      const path = P.GET_FORM_BY_ID_AND_STEP(shumaId, id);

      return isStepAllowed(step) && (
        <React.Fragment key={ind}>
          <StepNumber
            status={stepStatus[`step${id}_status`]}
            path={path}
            hoverTopic={getTopic(hoverTopic, shumaTypeID)}
            topic={getTopic(topic, shumaTypeID)}
            stepIcon={stepIcon}
          />
          {(ind < steps.length - 1) && <Dash/>}
        </React.Fragment>
      );
    })
  }

  return (
    <FormContainer>
      <div className={styles.firmShumaTitle}>{firmShumaID}</div>
      <div className={classNames(styles.navBarContainer, {[styles.step9Container]: formId === '9'})}>
        <div className={styles.navBar}>
          {renderSteps()}
        </div>
      </div>
      {
        (stepDataLoading && allowShowSpinner)
          ? <SpinnerContainer/>
          : (
            <Switch>
              <Route
                exact
                path={P.INSPECTION_ID}
                render={() => shumaId &&
                  <Redirect to={P.GET_FORM_BY_ID_AND_STEP(shumaId)}/>
                }
              />
              {steps.map(renderFormRoute)}
            </Switch>
          )
      }
      <PopupMessage/>
    </FormContainer>
  );
};

export default InspectionFormPageView;